module.exports = __webpack_public_path__ + "img/product-preview-90.2d383f2.png";